export const serviceData = [
  [
    '제1조 (목적)',
    `
          본 계약은 쿠모의 쿠폰 적립 서비스에 대한 내용의 정의 및 서비스를 받는 자(이하 "매장주"라 한다)와 쿠모 사이에 체결되는 계약에 관한 권리, 의무의 내용을 규정함을 목적으로 한다.
        `,
  ],
  [
    '제2조 (용어의 정의)',
    `
          이 약관에서 사용하는 용어의 정의는 다음과 같다.
      
          1. 매장: "쿠모"와 서비스 이용 관련 적법하게 계약을 체결한 곳으로, "매장주"가 직접 운영하거나 "매장주"와 계약관계에 있는 매장을 말한다.
          
          2. 쿠모: 고객에게 쿠폰 적립을 해주는 서비스를 제공함으로써 편리하게 매장의 고객을 관리할 수 있도록 하는 서비스를 말한다.
          
          3. 고객: 쿠모 또는 쿠모 서비스를 정상적으로 이용할 수 있는 자로서 "쿠모"가 정한 기준 및 절차에 따라 서비스에 가입한 자를 말한다.
        `,
  ],
  [
    '제3조 (계약의 성립)',
    `
        1. 서비스 이용계약은 "매장주" 본인 또는 대리인이 서비스 이용 신청서를 작성하여 날인 후, "쿠모"에 제출하고 "쿠모"가 이를 승인함으로써 성립한다.
  
        2. "쿠모"는 계약의 성립에 있어 사업자등록증 사본, 통장 사본 등 부가적인 증빙자료를 "매장주"에게 요구할 수 있으며, "매장주"는 정당한 사유가 없는 한 해당 자료를 "쿠모"에 제공하여야 한다.
      `,
  ],
  [
    '제4조 (계약의 변경)',
    `
      1. 본 계약을 체결하였던 "쿠모"와 "매장주"가 상호 합의를 통해 계약조건을 변경하는 경우, 변경된 계약 내용으로 양 당사자가 재계약을 체결하여야 한다.
    `,
  ],
  [
    '제5조 (양도금지 및 비밀유지)',
    `
      1. "쿠모"와 "매장주"는 서면에 의한 사전동의 없이 본 계약상의 권리와 의무를 제3자에게 양도 또는 이전할 수 없다.
    `,
  ],
  [
    ' 제6조 (통지의무)',
    `
      1. "쿠모" 또는 "매장주"에게 다음 각 호에 해당하는 사유가 발생하였을 때는 즉시 상대방에게 서면으로 통지하여야 한다.

      가. 상호 변경

      나. 서비스내용 변경요청

      다. 폐업, 업종변경, 회사합병 등의 결정

      라. 매장 대표자, 사업자등록번호, 주소 변경, 매장 이전, 폐쇄

      마. 본 계약 정산 관련 결제 방식의 변경

      바. 본 계약 제10조 제2항의 각 호에 기재된 사유

      사. 기타 본 약관의 지속에 영향을 미칠 수 있는 사항
    `,
  ],
  [
    '제7조 (쿠모 및 매장주의 의무사항)',
    `
      1. "쿠모"의 의무사항

      가. "쿠모"는 본 계약이 정하는 바에 따라 "매장주"와 "고객" 대상 지속적이고 안정적으로 서비스를 제공하기 위해서 노력한다.

      2. "매장주"의 의무사항

      가. "매장주"는 그 피용자 ∙ 종업원에 대한 교육을 수시로 실시하여 "고객"이 매장에서 쿠모 서비스를 제공받는 데 불편함이 없도록 하여야 하며, 자격 있는 피용자 · 종업원을 통해 "고객"에게 쿠모 서비스를 제공하여야 한다.

      나. "매장주"는 판매하는 물품 등에 대하여 가격할인기간을 포함하여 "고객"이 언제든지 보유한 적립 쿠폰을 사용할 수 있도록 하여야 한다. 다만, "매장주"가 사전에 "고객"이 확인 가능한 운영정책으로 표시한 경우, 특정 매장 또는 물품 등에 대하여 해당 혜택의 사용을 제한할 수 있다.
    `,
  ],
  [
    '제8조 (서비스 이용료)',
    `
      서비스 이용료의 종류와 금액은 "매장주"가 가입하는 서비스에 따라 "쿠모"가 정하며, 그 구체적인 내용은 쿠모 공식 웹사이트에 게시하기로 한다. "매장주"는 약정 기간 및 납부 방식을 직접 선택할 수 있다.
    `,
  ],
  [
    '제9조 (서비스 이용료의 청구 및 납부)',
    `
      1. "쿠모"는 "매장주"의 매장에 대한 서비스 개시일자를 서비스 이용요금의 기산일로 하여, "매장주"의 서비스 이용요금을 "매장주"에게 청구한다.

      2. "매장주"는 매월 약정한 일자에 약정한 이용요금을 "쿠모"에 납부해야 한다.

      3. "쿠모"가 청구한 요금에 이의가 있을 경우, "매장주"는 그 내용을 서면 또는 이메일로 "터치웍스"에게 통지하여야 하며, "터치웍스"는 "매장주"의 이의제기 내용에 대해 조사 후 이의 제기 내용에 타당성이 있다고 판단되는 경우 해당 조정금액을 익월 청구에 반영하여 청구한다.

      4. "매장주"는 이의 제기를 이유로 "쿠모"가 청구한 서비스 이용요금의 납부를 지연할 수 없으며, 납기 내에 청구된 금액을 우선 납부하여야 한다.

      5. "쿠모"는 서비스 이용료를 '매장주'에게 지급해야 하는 정산 대금에서의 공제 등으로 징수할 수 있으며, "쿠모"와 "매장주" 간의 서면 협의에 따라 서비스 이용료 및 징수 방법을 다르게 정할 수 있다.
    `,
  ],
  [
    '제10조 (계약해지 및 이용중지)',
    `
      1. 아래 각 호의 하나에 해당하는 경우 일방 당사자는 귀책사유가 있는 상대방에게 서면 통지로서 본 계약을 즉시 해지하거나 "매장주"의 해당 매장에 대한 서비스 제공을 중지할 수 있다.

      가. 일방 당사자가 영업정지, 폐업, 기업회생절차, 화의 등이 발생한 경우

      나. 주요 재산에 대한 (가)압류등으로 본 계약을 정상적으로 이행할 수 없는 경우

      2. 당사자 일방이 다음 각 호의 하나에 해당하는 경우에는 귀책사유가 있는 상대방에게 시정을 최고한 후 상대방이 최고를 받은 날로부터 10일 이내에 그 시정을 완료하지 않을 경우, 서면 통지로써 본 계약을 해지하거나 시정이 완료될 때까지 "매장주"의 매장에 대한 서비스 제공을 중지할 수 있다.

      가. "쿠모" 또는 "매장주"가 본 계약을 위반하거나 이행하지 않을 경우

      나. "매장주"가 "쿠모"에게 서비스 이용요금을 2개월을 연속하여 납기 내에 납부하지 않을 경우 (납부하지 않은 해당 매장에 한함)

      다. 관련 법령에 위반되는 물품을 판매하거나 판매 자격을 갖추지 아니하고 물품을 판매할 경우

      라. "매장주" 또는 "매장주"의 매장이 관련 법령을 위반하거나 "매장주"의 책임 있는 사유로 "쿠모"가 명예 실추 등 유/무형적 손해를 입은 경우
    `,
  ],
  [
    '제11조  (중도 계약 해지시 고객 보호를 위한 이행사항)',
    `
      1. 본 계약이 일방 당사자의 귀책사유로 중도해지되거나 계약기간 만료로 계약종료시, 양 당사자는 계약해지일 현재 사용중인 기존 고객에 대한 지속적이고 안정적인 서비스 제공을 위해 다음 각 호의 사항을 이행하기로 한다.

      가. 만약 "매장주"가 본 계약을 해지하고자 하는 경우, 해지사유를 기재하여 "쿠모"가 정하는 방법에 따라 해지를 요청하여야 한다.

      나. "매장주"가 "쿠모"에게 서비스 사용 이력이 있는 고객정보 조회를 요구하는 경우, "쿠모"는

      계약해지일로부터 최대 3개월간 범위 내에서 해당 기능을 제공한다.
    `,
  ],
  [
    '제12조 (할인반환금)',
    `
        1. "매장주"의 의사 또는 귀책사유에 의해 약정 기간 중 계약이 해지되었을 경우 "매장주"는 "쿠모"에 할인반환금을 지급해야 한다.

        2. 월납 요금제로 약정 계약 후 약정기간 내에 해지할 경우, "쿠모"는 아래 계산식으로 계산된 할인반환금(부가세 포함)을 "매장주"에게 청구한다.

        할인반환금 = {약정기간×(무약정 시 월납 이용료-약정 시 월납 이용료)} × {(약정기간-약정 후 이용기간)/약정기간}

        3. "매장주"에게 아래 각 호의 사유가 발생하였을 경우, 약정기간 중 계약이 해지되더라도 할인반환금의 납부 의무가 없다.

        가. 계약일로부터 7일 이내에 해지 요청을 한 때

        나. 휴업 또는 폐업신고를 한 때

        다. 영업정지 처분을 받은 때

        라. 파산 또는 회생절차 개시의 신청이 있는 때
  `,
  ],
  [
    '제13조 (이용요금 환급)',
    `
    1. "매장주"가 1개월이 초과되는 연속적 이용계약 체결 및 그에 따른 이용요금을 납부한 후 중도 해지를 요구하는 경우, "매장주"는 "쿠모"에게 서비스를 이용하지 못한 잔여 기간에 대한 이용요금 환급을 요구할 수 있다.

    2. 선납 요금제로 계약 및 그에 따른 이용요금을 납부한 후 중도 해지를 요구하는 경우, "쿠모"는 아래의 계산식으로 잔여기간에 대한 이용요금(부가세 포함)을 "매장주"에게 환급하기로 한다.

    환급금 = 기납부요금-해지 시점까지의 사용요금(무약정 시 월납 이용료×이용기간)
    `,
  ],
  [
    '제14조 (라이선스 인정조건)',
    `
        "쿠모"가 제공하는 솔루션의 저작권 및 소유권은 "쿠모"에게 있다. "매장주"는 본 계약서의 범위 내에서 그 사용권리를 부여 받는다.
    `,
  ],
  [
    '제15조 (손해배상)',
    `
        당사자 일방이 본 계약을 위반하여 상대방에게 손해를 입힌 경우, 귀책사유가 있는 당사자 일방은 상대방이 입은 모든 손해를 배상하여야 한다.

        단, 천재지변, 전쟁, 사변, 폭동, 쟁의행위 또는 이에 준하는 긴급사태 등 불가항력으로 인한 계약의 불이행은 계약위반으로 보지 아니한다.
    `,
  ],
  [
    '제16조 (분쟁의 해결 및 관할법원)',
    `
        본 계약과 관련하여 분쟁이 발생한 경우 각 당사자는 관계법령 및 상관례에 따라 신의 성실을 바탕으로 서로 호혜적 차원에서 합의하여 해결한다.

        합의가 성립되지 아니하여 소송을 제기하는 경우에는 서울중앙지방법원을 제1심의 전속적 합의관할법원으로 한다.
    `,
  ],
  [
    '제17조 (기타)',
    `
        본 계약에 명시되지 않은 사항은 관계법령 및 상관습에 따라 양 당사자가 상호 협의하여 결정하기로 한다.
    `,
  ],
  [
    '부칙',
    `
    공지일자 : 2024년 2월 17일 | 
    시행일자 : 2024년 2월 21일
    `,
  ],
];

export const privateData = [
  [
    '1. 수집정보',
    `
        상호명, 대표자명
        `,
  ],
  [
    '(1) 이용목적',
    `
        서비스 이용에 따른 본인 식별·인증 절차에 이용
        `,
  ],
  [
    '(2) 개인정보의 보유 및 이용 기간',
    `
        서비스 해지한 날로부터 6개월 경과 후 삭제(요금정산, 요금 과오납 등 분쟁 대비를 위함)
        
        `,
  ],
  [
    '2. 수집정보',
    `
        매장 주소, 매장 전화번호, 휴대폰번호, 이메일 주소
        `,
  ],
  [
    '(1) 이용목적',
    `
        요금청구 등 서비스 관련 고지 사항 전달, 본인 의사 확인, 신상품 안내, 불만 처리 등 원활한 의사소통 경로의 확보에 이용
        `,
  ],
  [
    '3. 수집정보',
    `
        은행명, 계좌번호, 예금주명, 계좌번호, 카드사명, 카드번호, 유효기간, 예금주(카드주) 주민등록번호 앞자리, 휴대폰번호
        `,
  ],
  [
    '(1) 이용목적',
    `
        요금청구 등 요금 관련 업무
        `,
  ],
  [
    '4. 수집정보',
    `
        매장명, 지점명, 매장전화번호, 매장주소, 업종/업태, 매장소개, 디자인 파일
        `,
  ],
  [
    '(1) 이용목적',
    `
        쿠모 모바일 앱 내 매장페이지 생성을 통한 매장 쿠폰 적립 서비스 제공
        `,
  ],
  [
    '(2) 개인정보의 보유 및 이용 기간',
    `
        서비스 해지한 날로부터 6개월 경과 후 삭제 (End User의 서비스 이용기록 보호를 위함)
        `,
  ],
];
